import { HttpClient } from '@angular/common/http';
import { catchError, of } from 'rxjs';
import { map } from 'rxjs/operators';

export function initializeThirdPartyLibrary(http: HttpClient, libraryUrl: string) {
  return () =>
    http.jsonp(libraryUrl, 'callback').pipe(
      map(() => true),
      catchError(() => of(false))
    );
}
